import type { InternApplication } from './types';

export async function submitInternApplication(application: InternApplication): Promise<{
  id: string;
  message: string;
}> {
  const res = await fetch('/.netlify/functions/submit-intern-application', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ application }),
  });

  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || 'Could not submit application');
  }

  return data;
}
